import { Form as FormikForm } from 'formik';
import styled from 'styled-components/macro';
import { layout, radius, shadow, space } from '../../../theme/tokens';

export const Form = styled(FormikForm)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: calc(100% - 2 * ${layout.gutter});
  max-width: 60rem;
  max-height: calc(100% - 2 * ${space[4]});
  overflow-y: auto;
  padding-bottom: ${space[4]};
  background: ${({ theme }) => theme.appBackground};
  border-radius: ${radius.lg};
  box-shadow: ${shadow.lg};
`;

export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
